import React, { useState } from "react";

export default function ProportionBar() {
  const [valA, setValA] = useState(2);
  const [valB, setValB] = useState(3);

  // We'll keep it super simple: 
  // We'll create two <div> bars side by side, representing the ratio valA : valB.
  
  // The total ratio sum:
  const sum = valA + valB;
  // We'll define a total width in pixels:
  const totalWidth = 300;
  // Each "unit" is totalWidth / (valA + valB)
  const unit = totalWidth / sum;

  return (
    <div style={{ margin: "10px 0", padding: "10px", border: "1px solid #ccc" }}>
      <h4>Proportion Bar: A : B</h4>
      <div style={{ marginBottom: "8px" }}>
        <label style={{ marginRight: 10 }}>
          A: 
          <input
          className="inputBox"
            type="number"
            value={valA}
            onChange={(e) => setValA(Number(e.target.value) || 1)}
            style={{ width: 60, marginLeft: 5 }}
          />
        </label>
        <label>
          B: 
          <input
          className="inputBox"
            type="number"
            value={valB}
            onChange={(e) => setValB(Number(e.target.value) || 1)}
            style={{ width: 60, marginLeft: 5 }}
          />
        </label>
      </div>

      <p>
        Current ratio: <strong>{valA}:{valB}</strong> 
      </p>

      {/* The "bar" visualization: two colored divs side by side */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: valA * unit,
            height: 30,
            backgroundColor: "#ff7675",
            marginRight: 2
          }}
        />
        <div
          style={{
            width: valB * unit,
            height: 30,
            backgroundColor: "#74b9ff"
          }}
        />
      </div>
      <p>
  We show the total ratio on a single bar with two color separating <strong>Part A</strong> and <strong>Part B</strong><> </>
  to help you see how each part of the ratio compares. If your numbers are 
  2 and 3, the total is 5, so the first bar is 2/5 of the total length and 
  the second bar is 3/5.
</p>
    </div>
  );
}
